import styles from "./index.module.scss";
import { ShareIcon } from "src/assets";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import FtShare from "@ft/share";
import { useLanguage } from "src/hooks";
import { autorun } from "mobx";
import { FTImageStore } from "src/store";
import { EnumsShowStatus } from "src/constant";
import {
  actionClickPopTypeAnlazy,
  actionSharePopAnlazy
} from "src/analyze/actions";

const Share = ({ isMobile }) => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();

  const [hover, setHover] = useState(false);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    autorun(() => {
      if (
        FTImageStore.currentEffect?.aigc &&
        FTImageStore.showStatus === EnumsShowStatus.result
      ) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    });
  }, []);

  useEffect(() => {
    function exe(el) {
      if (
        !(
          el.target ===
            document.querySelector(`.${styles["share-icon-fra"]}`) ||
          document
            .querySelector(`.${styles["share-icon-fra"]}`)
            ?.contains(el.target as HTMLDivElement)
        )
      ) {
        setHover(false);
        window.removeEventListener("click", exe);
      }
    }
    if (hover) {
      window.addEventListener("click", exe, {
        capture: true
      });
    }
  }, [hover]);

  if (!open) {
    return null;
  }
  return (
    <>
      {show &&
        isMobile &&
        createPortal(
          <div
            onClick={() => {
              setShow(false);
            }}
            className={styles["fix-content"]}>
            <FtShare
              onCopied={() => {
                actionClickPopTypeAnlazy("copy");
              }}
              tipMode
              isMobile={true}
              shareLink={"https://goart.fotor.com/"}
              theme='light'
              onClose={() => {
                setHover(false);
              }}
              shareDesc={
                "I'm having fun making AI art with Fotor! This free web tool is awesome, with the latest Ghibli styles and tons of creative effects to explore. https://goart.fotor.com/"
              }
              desc={t("goart_fotor_friend_website")}
              title={t("goart_fotor_friend")}
              env={"production"}
              open={true}
              coverSrc={
                "https://img-pub-fotor.s3.us-west-2.amazonaws.com/assets/fotor/b0ba06646dda49a3865948d5e84f8e10.jpg"
              }
              shareTo={[
                "discord",
                "facebook",
                "twitter",
                "pinterest",
                "linkedin"
              ]}
              zIndex={30000}
              onShared={(type) => {
                switch (type) {
                  case "linkedin":
                    actionClickPopTypeAnlazy("share_linkedIn");
                    break;
                  case "pinterest":
                    actionClickPopTypeAnlazy("share_pinterest");
                    break;
                  case "twitter":
                    actionClickPopTypeAnlazy("share_twitter");
                    break;
                  case "facebook":
                    actionClickPopTypeAnlazy("share_facebook");
                    break;
                  case "discord":
                    actionClickPopTypeAnlazy("share_discord");
                    break;
                }
              }}
            />
          </div>,
          document.body
        )}

      {isMobile && (
        <div
          onClick={() => {
            setShow(true);
            actionSharePopAnlazy("share");
          }}
          className={styles["share-icon-fra-mobile"]}>
          <ShareIcon width={16} />
        </div>
      )}

      {!isMobile && (
        <div
          onClick={() => {
            actionSharePopAnlazy("share");
            setHover(true);
          }}
          className={styles["share-icon-fra"]}>
          {hover && (
            <div
              onClick={(el) => {
                el.stopPropagation();
              }}
              className={styles["share-pop"]}>
              <FtShare
                onCopied={() => {
                  actionClickPopTypeAnlazy("copy");
                }}
                tipMode
                isMobile={isMobile}
                shareLink={"https://goart.fotor.com/"}
                theme='light'
                onClose={() => {
                  setHover(false);
                }}
                shareDesc={
                  "I'm having fun making AI art with Fotor! This free web tool is awesome, with the latest Ghibli styles and tons of creative effects to explore. https://goart.fotor.com/"
                }
                desc={t("goart_fotor_friend_website")}
                title={t("goart_fotor_friend")}
                env={"production"}
                open={true}
                coverSrc={`${process.env.PUBLIC_URL}/img/background/Twitter.jpg`}
                shareTo={[
                  "discord",
                  "facebook",
                  "twitter",
                  "pinterest",
                  "linkedin"
                ]}
                zIndex={30000}
                onShared={(type) => {
                  switch (type) {
                    case "linkedin":
                      actionClickPopTypeAnlazy("share_linkedIn");
                      break;
                    case "pinterest":
                      actionClickPopTypeAnlazy("share_pinterest");
                      break;
                    case "twitter":
                      actionClickPopTypeAnlazy("share_twitter");
                      break;
                    case "facebook":
                      actionClickPopTypeAnlazy("share_facebook");
                      break;
                    case "discord":
                      actionClickPopTypeAnlazy("share_discord");
                      break;
                  }
                }}
              />
            </div>
          )}
          <ShareIcon width={16} />
          {t("goart_share_btn")}
        </div>
      )}
    </>
  );
};
export default Share;
